import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { LayoutSplashScreen } from "../../../context/LayoutContext";
import * as auth from "../_redux/authRedux";

const Logout = (props) => {
  const { hasAuthToken, logout } = props;

  useEffect(() => {
    logout();
  });

  return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
};

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
